import {TagsEditor} from 'shells/tags-editor/tags-editor';
import type {Tag, User} from 'shells/tags-editor/tags-editor';

import {useGetLeadTagMaps} from '../graphql/hooks';
import {useUpdateLeadTags} from '../graphql/hooks/use-update-lead-tags';
import {useLeadTags} from '../hooks/use-lead-tags';

import styles from '../../../core-entity/styles/tag-editor.module.css';

interface Lead {
    id: string;
    number: number | null;
}

type Props = {
    lead: Lead;
    user: User | null | undefined;
    fetchTags: (arg1: string) => Promise<any>;
    maxItems?: number;
};

export function LeadTagsEditor(props: Props) {
    const {leadTagMaps} = useGetLeadTagMaps(props.lead.id, props.lead.number);
    const {leadTags, handleFetchTags} = useLeadTags(leadTagMaps, props.fetchTags);
    const {updateLeadTags, isLoading: isUpdatingTagsLoading} = useUpdateLeadTags();

    const handleUpdateTags = (tags: Tag[]) => {
        if (isUpdatingTagsLoading) return;

        updateLeadTags(props.lead.id, tags);
    };

    return (
        <div className={styles['tag-container']}>
            <TagsEditor
                key={props.lead.id}
                user={{
                    id: props.user ? props.user.id : '',
                    name: props.user ? props.user.name : '',
                }}
                fetchTags={handleFetchTags}
                appliedTags={leadTags}
                maxItems={props.maxItems}
                onUpdateTags={handleUpdateTags}
            />
        </div>
    );
}
